export default __webpack_public_path__ + "static/media/instagram.82b95008.png";